import { render, staticRenderFns } from "./UserNotiModal.vue?vue&type=template&id=5e2477c7&"
import script from "./UserNotiModal.vue?vue&type=script&lang=js&"
export * from "./UserNotiModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports